import React from 'react';
import { ExternalLink } from 'lucide-react';
import { getImageUrl } from '../lib/imageUtils';

const Clients = ({ clients = [] }) => {
  const visibleClients = clients.filter(c => c.logo_url && c.logo_url.trim() && c.name);

  if (visibleClients.length === 0) return null;

  const renderLogo = (client, index) => {
    const content = (
      <>
        <img
          src={getImageUrl(client.logo_url)}
          alt={client.name}
          title={client.name}
          className="max-h-full max-w-full w-auto h-auto object-contain"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = `<div class="text-center text-gray-700 font-semibold">${client.name}</div>`;
          }}
        />
        {client.website_url && (
          <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
            <ExternalLink size={14} className="text-blue-600" />
          </div>
        )}
      </>
    );

    const baseClasses = "relative bg-white border-2 border-gray-100 rounded-xl p-4 md:p-6 hover:border-blue-300 hover:shadow-xl transition-all grayscale hover:grayscale-0 flex items-center justify-center h-28 md:h-32 group overflow-hidden";

    if (client.website_url && client.website_url.trim()) {
      return (
        <a
          key={index}
          href={client.website_url.trim()}
          target="_blank"
          rel="noopener noreferrer"
          className={`${baseClasses} cursor-pointer hover:-translate-y-1`}
          data-testid={`client-logo-${index}`}
          aria-label={`Visit ${client.name} official website`}
        >
          {content}
        </a>
      );
    }

    return (
      <div key={index} className={baseClasses} data-testid={`client-logo-${index}`}>
        {content}
      </div>
    );
  };

  return (
    <section className="py-20 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-sm font-semibold text-blue-600 uppercase tracking-wider mb-3">Our Partners</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Trusted By <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-800">Leading Brands</span>
          </h3>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-500 to-yellow-600 mx-auto mb-4"></div>
          <p className="text-gray-500 text-sm">Click on a brand to visit their official website</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8 items-center max-w-6xl mx-auto">
          {visibleClients.map((client, index) => renderLogo(client, index))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
